import { createBrowserRouter, Navigate } from 'react-router-dom'
import ErrorBoundaryPage from './ErrorBoundaryPage'
import Layout from 'src/layout/view'
import DefaultJoinFormPage from 'src/pages/DefaultJoinFormPage'
import TermsWindowPopup from 'src/components/TermsWindowPopup'
import BillLetterJoinFormPage from 'src/pages/BillLetterJoinFormPage'
import RecaptchaJoinFormPage from 'src/pages/RecaptchaJoinFormPage'
import Rop03JoinFormPage from 'src/pages/Rop03JoinFormPage'
import Rop04JoinFormPage from 'src/pages/Rop04JoinFormPage'
import { themeV1, themeV2 } from 'src/styles/theme'

export const router = createBrowserRouter([
  {
    element: <Layout theme={themeV1} />,
    errorElement: <ErrorBoundaryPage />,
    children: [
      // 기본 가입창 (A/B: /:form/:pCode/slot{N}/:requestId/:telecom)
      {
        element: <DefaultJoinFormPage />,
        path: '/:form/:pCode/:slot/:requestId/:telecom',
        children: [{ path: ':fixedTelecom' }],
      },
      {
        element: <DefaultJoinFormPage />,
        path: '/:form/:pCode/:requestId/:telecom',
        children: [{ path: ':fixedTelecom' }],
      },
      //skt billlette pCode: bill-letter_01 : 부가 서비스, bill-letter_02, bill-letter_03 : 생활서비스
      {
        path: '/bill/:pCode/:slot/:requestId/:telecom',
        children: [
          { path: '', element: <Navigate to="0" replace /> },
          { path: ':fixedTelecom', element: <BillLetterJoinFormPage /> },
        ],
      },
      {
        path: '/bill/:pCode/:requestId/:telecom',
        children: [
          { path: '', element: <Navigate to="0" replace /> },
          { path: ':fixedTelecom', element: <BillLetterJoinFormPage /> },
        ],
      },
      // rop02 (리캡챠 전용 가입창)
      {
        element: <RecaptchaJoinFormPage />,
        path: '/rop02/:pCode/:slot/:requestId/:telecom',
        children: [{ path: ':fixedTelecom' }],
      },
      {
        element: <RecaptchaJoinFormPage />,
        path: '/rop02/:pCode/:requestId/:telecom',
        children: [{ path: ':fixedTelecom' }],
      },
      {
        element: <TermsWindowPopup />,
        path: 'terms/:telecom/:termsKey',
      },
    ],
  },
  {
    element: <Layout theme={themeV2} />,
    errorElement: <ErrorBoundaryPage />,
    children: [
      // rop03
      {
        element: <Rop03JoinFormPage />,
        path: '/rop03/:pCode/:slot/:requestId/:telecom',
        children: [{ path: ':fixedTelecom' }],
      },
      {
        element: <Rop03JoinFormPage />,
        path: '/rop03/:pCode/:requestId/:telecom',
        children: [{ path: ':fixedTelecom' }],
      },
      // rop04
      {
        element: <Rop04JoinFormPage />,
        path: '/rop04/:pCode/:slot/:requestId/:telecom',
        children: [{ path: ':fixedTelecom' }],
      },
      {
        element: <Rop04JoinFormPage />,
        path: '/rop04/:pCode/:requestId/:telecom',
        children: [{ path: ':fixedTelecom' }],
      },
      // rop05
      {
        element: <Rop04JoinFormPage />,
        path: '/rop05/:pCode/:slot/:requestId/:telecom',
        children: [{ path: ':fixedTelecom' }],
      },
      {
        element: <Rop04JoinFormPage />,
        path: '/rop05/:pCode/:requestId/:telecom',
        children: [{ path: ':fixedTelecom' }],
      },
    ],
  },
])

export default router
